import React from 'react';
import './Checkout.css';
import Subtotal from './Subtotal';
import { useStateValue } from './StateProvider';
import CheckoutProduct from './CheckoutProduct';
import Header from './Header';
import { useUserAuth } from './UserAuthContext';

function Checkout() {
  const [{ basket}, dispatch] = useStateValue(); // Add selectedSize to the state
  const { user } = useUserAuth();

  const cart = {
    fontSize: '40px',
  }

  if (window.innerWidth <= 600){
    cart.fontSize = '14px';
  }

  return (
    <div>
      <Header />
      <div className="checkout">
        <div className="checkout__left">
          <div className="checkout__title">
          <div style = {cart}>
          {user ? (
            <p>Thank you, {user.displayName} for coming this far! </p>
          ) : (
            <p>Sign-in now to proceed to Purchase</p>
          )}
        </div>
          <h2>Your Shopping Bag</h2><br/><hr/>
            {basket.length === 0 ? (
              <p className='empty'>Your bag is empty</p>
            ) : (
              basket.map((item) => (
                <CheckoutProduct
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  image={item.image}
                  price={item.price}
                  size={item.size} // Display the selected size
                />
              ))
            )}
          </div>
        </div>
        <div className="checkout__right">
          <Subtotal />
        </div>
      </div>
    </div>
  );
}

export default Checkout;
